<template>
  <el-dialog :visible.sync="dialogVisible" class="el-dialog-tip" :width="width" :show-close="false">
    <el-result icon="success" title="提交成功" subTitle="请根据提示进行操作">
      <template slot="icon">
        <el-image :src="imgSrc" style="width: 68px;"></el-image>
      </template>
      <template slot="subTitle">
        <span style="color: #5D6494;">我们将尽快与您联系 ({{ time }}s) </span>
      </template>
    </el-result>
  </el-dialog>
</template>

<script>
// import api from '@/api'
import { mapState } from 'vuex'
import { isAndroid, isIos } from '@/utils'
export default {
  name: 'App',
  data() {
    return {
      dialogVisible: false,
      time: 3,
      imgSrc: require('@/assets/imgs/tip-success.png'),
      width: '420px'
    }
  },
  methods: {
    init() {
      this.dialogVisible = true
      this.time = 3
      this.myInterval = setInterval(() => {
        if (this.time === 1) {
          this.dialogVisible = false
          clearInterval(this.myInterval)
        } else {
          this.time = this.time - 1
        }
      }, 1000)
      if (isAndroid() || isIos()) {
        this.width = '80%'
      }
    }
  },
  computed: {
    ...mapState([])
  },
  components: {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init(to, from)
    })
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    next()
  }
}
</script>

<style scoped lang="scss"></style>>



// WEBPACK FOOTER //
// src/components/tipSuccess.vue